import React, { createContext, useState } from "react";
import { Toast } from "../components/common/Toast";
import AreaService from "../services/AreaService";

export const AreaContext = createContext("AreaContext");

const AreaContextProvider = ({ children }) => {
	const [areaList, setAreaList] = useState([]);
	const [loadingAreaList, setLoadingAreaList] = useState(false);
	const [areaListErrorMsg, setAreaListErrorMsg] = useState("");
	const [totalElements, setTotalElements] = useState(0);

	const getAreaList = async (params) => {
		setLoadingAreaList(true);
		setAreaListErrorMsg("");
		try {
			const response = await AreaService.getAreaList(params);
			setAreaList(response.data.content);
			setTotalElements(response.data.totalElements);
		} catch (error) {
			const message = error.response
				? error.response.data.message
					? error.response.data.message
					: error.response.data
				: error.message;
			setAreaListErrorMsg(message);
			Toast("error", "Error", message);
		} finally {
			setLoadingAreaList(false);
		}
	};

	return (
		<AreaContext.Provider
			value={{
				getAreaList,
				areaList,
				totalElements,
				loadingAreaList,
				areaListErrorMsg,
			}}
		>
			{children}
		</AreaContext.Provider>
	);
};

export default AreaContextProvider;
